import { Component } from "react";

/**
 * Top-level render-error catch-all. Without this, any exception thrown
 * while rendering a route (a null-check miss, a malformed API response)
 * takes down the entire SPA to a blank white screen instead of a scoped,
 * recoverable fallback.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Unhandled render error:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-white px-6">
          <div className="card-swiss max-w-md w-full text-center py-12 px-8 space-y-4">
            <h1 className="font-display text-xl text-slate-900">
              Something went wrong
            </h1>
            <p className="text-sm text-slate-600 leading-relaxed">
              This page hit an unexpected error. Reloading usually fixes it —
              if it keeps happening, please contact support.
            </p>
            <button
              type="button"
              className="btn-primary"
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
